import ClubDogMemberConfiguration from '../dto/ClubDogMemberConfiguration';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubDogMemberConfigurationRepository {
    static find(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/options/dog-member-configuration`)
                .then((response) => resolve(ClubDogMemberConfiguration.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubId, clubApplicationSetting) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/options/dog-member-configuration`, clubApplicationSetting.serialize(),
                )
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
